import { createElement } from 'react';
import SortConfigFormItems from '../../../production/form/SortConfigFormItems';
import { ENTITIES } from '../../constants/customSortFieldConfigs';
import type { ReportEntityKey } from '../runtime/types/runtimeTypes';
import { normalizeReportDataObject } from '../transformers';
import type { EntityReportAdapter, EntityReportConfigureFormProps } from './EntityReportAdapter';

const SHORTLIST_REPORT_ADAPTER_KEY = 'shortlist-report-adapter';

type ShortlistReportRow = Partial<Record<ReportEntityKey, unknown>>;

export const shortlistEntityReportAdapter: EntityReportAdapter<ShortlistReportRow, ShortlistReportRow> = {
    key: SHORTLIST_REPORT_ADAPTER_KEY,
    entity: ENTITIES.shortlist,
    templateStrategy: 'documentContext',
    defaultReportPageSize: 200,
    buildTemplateContext: ({ previewData, locale }) => {
        const source: ShortlistReportRow = Array.isArray(previewData) ? previewData[0] || {} : previewData || {};

        return normalizeReportDataObject(source, locale);
    },
    getConfigureFormComponent: () =>
        function ShortlistSortConfigFormItems(props: EntityReportConfigureFormProps) {
            return createElement(SortConfigFormItems, props);
        }
};
